export const viteEnv = undefined;
